import { render, staticRenderFns } from "./PhototypeInfoModal.vue?vue&type=template&id=8b1658ea&scoped=true"
import script from "./PhototypeInfoModal.vue?vue&type=script&lang=js"
export * from "./PhototypeInfoModal.vue?vue&type=script&lang=js"
import style0 from "./PhototypeInfoModal.vue?vue&type=style&index=0&id=8b1658ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1658ea",
  null
  
)

export default component.exports